<mat-tab-group mat-align-tabs="start" [selectedIndex]="selectedIndex">
  <mat-tab label="Referrals">
    <app-driving-school-referrals></app-driving-school-referrals>
  </mat-tab>
  <mat-tab label="Commission On Orders">
    <app-driving-school-commission-earnings></app-driving-school-commission-earnings>
  </mat-tab>
</mat-tab-group>
